export type VehicleAspect = "green" | "yellow" | "red";
export type PedestrianAspect = "walk" | "flashing-dont-walk" | "dont-walk";

export interface SignalState {
  vehicle: VehicleAspect;
  pedestrian: PedestrianAspect;
  cycleSecond: number;
}

function modulo(value: number, divisor: number): number {
  return ((value % divisor) + divisor) % divisor;
}

export function signalOffsetSeconds(worldX: number, worldZ: number): number {
  return modulo(Math.floor(worldX / 80) * 7 + Math.floor(worldZ / 80) * 11, 88);
}

export function signalState(
  epochSeconds: number,
  worldX: number,
  worldZ: number,
  axis: 0 | 1,
  crosswalkLengthM: number,
): SignalState {
  const clearance = Math.ceil(crosswalkLengthM / 1.2) + 2;
  if (clearance >= 44) throw new Error("Crosswalk cannot clear within its signal half-cycle");
  const cycleSecond = modulo(
    Math.floor(epochSeconds) + signalOffsetSeconds(worldX, worldZ) - axis * 44,
    88,
  );
  const local = cycleSecond < 44 ? cycleSecond : cycleSecond - 44;
  const ownHalf = cycleSecond < 44;
  const vehicle: VehicleAspect = !ownHalf
    ? "red"
    : local < 38
      ? "green"
      : local < 42
        ? "yellow"
        : "red";
  const pedestrian: PedestrianAspect = !ownHalf
    ? "dont-walk"
    : local < 44 - clearance
      ? "walk"
      : "flashing-dont-walk";
  return { vehicle, pedestrian, cycleSecond };
}
